import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function ProductSpecRoutes() {
  return (
    <Routes>
      <Route path={Pages.ecom.product_spec.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.ecom.product_spec.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.ecom.product_spec.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.ecom.product_spec.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.ecom.product_spec.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.ecom.product_spec.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
